"use client";

import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { useTranslations } from "next-intl";
import {
  errorFromWindowLoadEvent,
  recoverFromWindowLoadError,
} from "@/lib/clerk-load-recovery";

export function ClerkLoadRecovery() {
  const t = useTranslations("Errors");
  const [showRetry, setShowRetry] = useState(false);

  useEffect(() => {
    const onEvent = (event: Event) => {
      const result = recoverFromWindowLoadError(
        errorFromWindowLoadEvent(event),
        {},
        { pathname: window.location.pathname },
      );
      if (result === "ignored") {
        return;
      }
      event.preventDefault();
      if (result === "show_retry") {
        setShowRetry(true);
      }
    };

    window.addEventListener("unhandledrejection", onEvent);
    window.addEventListener("error", onEvent);
    return () => {
      window.removeEventListener("unhandledrejection", onEvent);
      window.removeEventListener("error", onEvent);
    };
  }, []);

  if (!showRetry) {
    return null;
  }

  return (
    <div
      role="alert"
      className="fixed inset-0 z-[10060] flex items-center justify-center bg-(--mk-ink)/95 px-6"
    >
      <div className="mx-auto max-w-lg text-center">
        <div
          className="mb-6 ml-auto mr-auto flex h-16 w-16 items-center justify-center rounded-2xl"
          style={{
            background: "rgba(201,168,76,0.1)",
            border: "1px solid rgba(201,168,76,0.2)",
          }}
        >
          <WifiOff
            className="h-8 w-8"
            style={{ color: "#c9a84c" }}
            aria-hidden="true"
          />
        </div>
        <p
          className="mb-3 text-[11px] font-bold uppercase tracking-[0.13em]"
          style={{ color: "#c9a84c" }}
        >
          {t("clerkLoadLabel")}
        </p>
        <h2
          className="mb-3 font-serif text-[32px] font-black leading-[1.1] tracking-[-0.025em]"
          style={{ color: "#faf6ee" }}
        >
          {t("clerkLoadTitleBefore")}{" "}
          <em className="italic" style={{ color: "#c9a84c" }}>
            {t("clerkLoadTitleGold")}
          </em>
        </h2>
        <p
          className="mb-8 text-[15px] leading-relaxed"
          style={{ color: "rgba(250,246,238,0.55)" }}
        >
          {t("clerkLoadBody")}
        </p>
        <button
          type="button"
          onClick={() => {
            window.location.reload();
          }}
          className="cursor-pointer rounded-full px-6 py-3 text-sm font-semibold transition-opacity hover:opacity-90 active:opacity-75"
          style={{
            background: "linear-gradient(135deg, #c9a84c, #e8c96a)",
            color: "#0e0c0a",
          }}
        >
          {t("tryAgain")}
        </button>
      </div>
    </div>
  );
}
